/* src/app/shared/components/layout/nav-item/nav-item.component.scss */
.navbar-item-link {
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 20px;
  font-weight: bold;
  min-height: 48px;
  margin-right: 15px;
  position: relative;
}
.navbar-item-link--is-active {
  background: rgba(236, 236, 237, 0.9803921569);
  cursor: default !important;
}
.navbar-item-link--is-active:hover {
  color: var(--mp-link-header-color) !important;
}
.navbar-item-link--is-active:after {
  content: "";
  display: block;
  width: 70%;
  left: 50%;
  transform: translateX(-50%);
  height: 3px;
  border-radius: 3px 3px 0 0;
  position: absolute;
  bottom: 0;
  background: var(--mp-link-color);
}
.navbar-item-link--icon {
  display: flex;
  flex-flow: row nowrap;
  align-items: baseline;
  white-space: nowrap;
  position: relative;
  top: -4px;
}
.navbar-item-link--icon i {
  margin-right: 5px;
  position: relative;
  top: 2px;
  font-size: 1.125rem;
}
/*# sourceMappingURL=nav-item.component.css.map */
